export var RCStatusType;
(function (RCStatusType) {
    RCStatusType["IN_PROGRESS"] = "in_progress";
    RCStatusType["REVIEWING"] = "reviewing";
    RCStatusType["SUCCESSFUL"] = "successful";
    RCStatusType["IRREGULAR"] = "irregular";
    RCStatusType["CANCELED"] = "canceled";
})(RCStatusType || (RCStatusType = {}));
//# sourceMappingURL=RCStatusType.js.map